import React from 'react';
import { EcdContentPage } from '../models/ecd-page-models';
import { Wysiwyg } from '../components/wysiwyg';
import { BlockFactory } from '../components/block-factory';

interface Props {
    pageData: EcdContentPage,
}

function EcdContentPageView(props: Props) {    
    const { pageData } = props;    

    function RenderContentArea(){
        return (<>
            { pageData?.contentArea?.map((a) => <BlockFactory blockData={a} />) }
        </>);
    }

    return (        
        <>      
            <h3 className='ecd-page-content-title'>
                {pageData?.pageTitle}
            </h3>      
            <div className='ecd-page-content-section'>
                <Wysiwyg content={pageData?.mainContent} />            
                <RenderContentArea />
            </div>            
        </>
    );
}

export default EcdContentPageView;
